import { useRouter } from "next/router";
import React, { useContext, useRef, useState, useTransition } from "react";
import { useForm } from "react-hook-form";
import Heading from "../../components/Heading";
import brandModel from "../../models/brands.model";

import helper from "../../lib/helper";
import _ from "lodash";
import Link from "next/link";
import { Card } from "react-bootstrap";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);
    const [preview, setPreview] = useState('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')
    const editorRef = useRef(null);
    const router = useRouter();
    const {
        register,
        setValue,
        handleSubmit,
        watch,
        formState: { errors,isSubmitting },
        setError,
    } = useForm();

    const onSubmit = handleSubmit(async (data, event) => {
        console.log('errorrs', errors)
        const formData = new FormData(event.target);
        await brandModel
            .create(formData)
            .then((response) => {
                helper.sweetalert.toast(response.data?.message, 'success');
                router.push("/brands");
            })
            .catch((error) => {
                console.log(error?.response?.data?.errors);
                helper.sweetalert.toast(error?.response?.data?.message, 'error');
                _.each(error.response?.data?.errors, function (err, errorKey) {
                    setError(errorKey, { type: "required", message: err });
                });
            });
    });
    const onSelectFile = e => {
        console.log(e.target.files[0])
        // I've kept this example simple by usin;g the first image instead of multiple
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setPreview(objectUrl);
        //setValue("avatar", e.target.files[0]);
    }
    return (
        <>
            <Heading title="Create brand" showLoader={showLoader} >
                <Link className="btn btn-primary btn-sm" href={`/brands`}>
                    <i className="bi bi-list" /> List
                </Link>
            </Heading>
            <form onSubmit={onSubmit} className="container-fluid">
                <div className="card row col-md-12">
                    <div className="card-header">Brand Creation Form</div>
                    <div className="card-body row">
                        <div className="col-md-3 me-3 position-relative border-end">

                            <img src={preview}
                                className="w-100 border rounded" alt="" />
                            <div className="m-1">
                                <label className="custom-file-upload">
                                    <input type="file" className="d-none" accept="image/*" {...register('image', { onChange: onSelectFile })} />
                                    <b className="btn btn-dark">Upload</b>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-9 row">
                        <div className="col-md-12">
                            <label className="form-label">Brand-Name</label>
                            <input
                                placeholder="Enter brand-name"
                                type="text"
                                className={`form-control ${errors?.brand_name && "is-invalid"}`}
                                {...register("name", {

                                    required: 'brand-name is required',
                                })}
                            />
                            <div className="invalid-feedback">
                                {errors.brand_name && errors.message}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Size</label>
                            <input
                                placeholder="Enter months"
                                type="text"
                                className={`form-control ${errors?.info && "is-invalid"}`}
                                {...register("info[size]")
                                }
                            />
                            <div className="invalid-feedback">
                                {errors.info && errors.message}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Title</label>
                            <input
                                placeholder="Enter title"
                                type="text"
                                className={`form-control ${errors?.title && "is-invalid"}`}
                                {...register("title", {

                                    onBlur: () => { setValue('slug', helper.text.slug(event.target.value)) },

                                    
                                })}
                            />
                            <div className="invalid-feedback">
                                {errors.title && errors.message}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Slug</label>
                            <input
                                placeholder="Enter slug"
                                type="text"
                                className={`form-control ${errors?.slug && "is-invalid"}`}
                                {...register("slug", {

                                    required: 'slug is required',
                                })}
                            />
                            <div className="invalid-feedback">
                                {errors.slug && errors.message}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Sort_index</label>
                            <input
                                placeholder="Enter sort_index"
                                type="number"
                                className={`form-control ${errors?.sort_index && "is-invalid"}`}
                                {...register("sort_index", {

                                    required: 'sort-index is required',
                                })}
                            />
                            <div className="invalid-feedback">
                                {errors.sort_index && errors.message}
                            </div>
                        </div>
                    </div>
                    </div>
                    <Card.Header>SEO</Card.Header>
                    <Card.Body>
                        <div className="col-md-12">
                            <label className="form-label">Meta-title</label>
                            <input
                                type="text"
                                className={`form-control ${errors?.metatitle && "is-invalid"}`}
                                {...register("meta[title]",)}
                            />
                            <div className="invalid-feedback">
                                {errors.metatitle && errors.metatitle.message}
                            </div>
                        </div>
                        <div className="col-md-12 mt-3">
                            <label className="form-label">Meta-description</label>
                            <textarea
                                type="text"
                                className={`form-control ${errors?.metadescription && "is-invalid"}`}
                                {...register("meta[description]",)}
                            />
                            <div className="invalid-feedback">
                                {errors.metadescription && errors.metadescription.message}
                            </div>
                        </div>
                        <div className="col-md-12 mt-3">
                            <label className="form-label">Meta-keywords</label>
                            <input
                                type="text"
                                className={`form-control ${errors?.metakeywords && "is-invalid"}`}
                                {...register("meta[keywords]",)}
                            />
                            <div className="invalid-feedback">
                                {errors.metakeywords && errors.metakeywords.message}
                            </div>
                        </div>
                    </Card.Body>
                    <div className="card-footer">
                        <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default Page;
